import { render, staticRenderFns } from "./AccessorialLocationList.vue?vue&type=template&id=710d7a7c&scoped=true"
import script from "./AccessorialLocationList.vue?vue&type=script&lang=js"
export * from "./AccessorialLocationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d7a7c",
  null
  
)

export default component.exports